// src/components/ProjectCard.jsx
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import "../assets/css/projectCard.css";

// Iframe Modal Component
function IframeModal({ project, onClose }) {
  // close on ESC
  useEffect(() => {
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onClose]);

  if (!project) return null;

  return (
    <div className="iframe-modal" onClick={onClose}>
      <div className="iframe-modal__inner" onClick={(e) => e.stopPropagation()}>
        <button className="iframe-modal__close" onClick={onClose}>
          &times;
        </button>
        <iframe
          src={project.websiteUrl}
          title={project.title}
          sandbox="allow-scripts allow-same-origin allow-forms"
          allowFullScreen
        />
      </div>
    </div>
  );
}

function ProjectCard({ img, title, category, light, websiteUrl }) {
  const [modalProject, setModalProject] = useState(null);

  const openModal = () => {
    if (!websiteUrl) return; // nothing to open
    setModalProject({ img, title, category, websiteUrl });
  };

  return (
    <>
      <div
        className={`project ${
          light ? "project-light" : ""
        } col-sm-6 col-md-4 col-lg-3`}
        data-has-website={!!websiteUrl}
      >
        <div onClick={websiteUrl ? openModal : undefined} style={{ cursor: websiteUrl ? 'pointer' : 'default' }}>
          <figure>
            <img src={img} alt={title} />
            <figcaption>
              <h3
                className="project-title"
                dangerouslySetInnerHTML={{ __html: title }}
              />
              <h4 className="project-category">{category}</h4>
              <div className="project-zoom" />
            </figcaption>
          </figure>
        </div>
      </div>

      {/* Modal renders here */}
      <IframeModal
        project={modalProject}
        onClose={() => setModalProject(null)}
      />
    </>
  );
}

ProjectCard.propTypes = {
  img: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired, // allow <br> tags inside string
  category: PropTypes.string.isRequired,
  light: PropTypes.bool,
  websiteUrl: PropTypes.string, // NEW: website URL from Firestore
};

export default ProjectCard;